<template>
  <div id="product-swapper" class="text-xs-center">
    <v-dialog v-model="dialog" width="1200" persistent>
      <v-card min-height="800">
        <v-card-text>
          <div class="swapper" v-if="dialog">
            <div class="settings">{{ $t("product_swapper.move_products") }}</div>

            <div class="pallets-view">
              <div id="left-pallet" class="left-pallet">
                <pallet-top
                  id="pallet-top-left"
                  v-if="palletLeft != null"
                  ref="palletTopLeft"
                  :pallet="palletLeft"
                  :divider="dividerLeft"
                />
              </div>
              <div id="right-pallet" class="right-pallet">
                <pallet-top
                  id="pallet-top-right"
                  v-if="palletRight != null"
                  ref="palletTopRight"
                  :pallet="palletRight"
                  :divider="dividerRight"
                />
              </div>
            </div>

            <div class="pallet-product-selector">
              <div class="pallet-from">
                <v-select v-model="palletLeft" :items="palletsLeft"></v-select>
              </div>
              <div class="pallet-to">
                <v-select v-model="palletRight" :items="palletsRight"></v-select>
              </div>
            </div>

            <div class="product-selector">
              <div class="products-left" v-if="palletLeft">
                <select id="select-from" class="select" @change="selectProduct('from')" multiple>
                  <option
                    v-for="(product, index) in palletLeft.products"
                    :key="index"
                    :value="JSON.stringify(product)"
                    @dblclick="loadProduct(product)"
                    @mouseover="loadSelectedProduct(product)"
                    @mouseout="mouseIsOver = -1"
                  >{{ product }}</option>
                </select>
              </div>
              <div class="products-right" v-if="palletRight">
                <select id="select-to" class="select" @change="selectProduct('to')" multiple>
                  <option
                    v-for="(product, index) in palletRight.products"
                    :key="index"
                    :value="JSON.stringify(product)"
                    @dblclick="unloadProduct(product)"
                    @mouseover="loadSelectedProduct(product)"
                    @mouseout="mouseIsOver = -1"
                  >{{ product }}</option>
                </select>
              </div>
              <div class="swapper-buttons">
                <button
                  class="button button-hover upload-button"
                  :disabled="palletLeft == null || palletRight == null"
                  @click="moveProducts()"
                >
                  <v-icon>arrow_forward</v-icon>
                </button>
                <button
                  class="button button-hover delete-button"
                  :disabled="palletLeft == null || palletRight == null"
                  @click="moveProducts()"
                >
                  <v-icon>arrow_back</v-icon>
                </button>
              </div>
            </div>

            <div class="dialog-buttons">
              <div class="confirm-button">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn color="green" @click="confirm" v-on="on">
                      <v-icon color="white">done</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("single_pallet_maker.confirm") }}</span>
                </v-tooltip>
              </div>
              <div class="cancel-button">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn color="red" @click="dialog = false" v-on="on">
                      <v-icon color="white">close</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("single_pallet_maker.cancel") }}</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Pallet from "@/models/Pallet.js";
import Product from "@/models/Product.js";
import PalletTop from "@/components/user/pallets/PalletTop.vue";
import Helper from "@/models/Helper.js";
export default {
  name: "product-swapper",
  props: {
    pallets: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      palletLeft: null,
      palletsLeft: [],
      palletRight: null,
      palletsRight: [],
      dividerLeft: 6,
      dividerRight: 6,
      palletsCopy: [],
      loadingProducts: [],
      unloadingProducts: [],
      onKeyUp: e => {
        if (e.key === "Escape") {
          this.dialog = false;
        }
        if (e.key === "Enter") {
          this.confirm();
        }
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.temporary = false;
        this.palletLeft = null;
        this.palletRight = null;
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
    palletLeft: {
      async handler() {
        if (!this.palletLeft) return;
        const palletIndex = this.palletsCopy
          .map(e => {
            return e.id;
          })
          .indexOf(this.palletLeft);
        if (palletIndex != -1) {
          this.palletLeft = this.palletsCopy[palletIndex];
        }
        this.palletsLeft = this.getPallets(this.palletRight);
        this.palletsRight = this.getPallets(this.palletLeft);
        await Helper.timeout(20);
        const palletTop = document.getElementById("left-pallet");
        this.dividerLeft = this.getDivider(this.palletLeft, palletTop);
      },
      deep: true
    },
    palletRight: {
      async handler() {
        if (!this.palletRight) return;
        const palletIndex = this.palletsCopy
          .map(e => {
            return e.id;
          })
          .indexOf(this.palletRight);
        if (palletIndex != -1) {
          this.palletRight = this.palletsCopy[palletIndex];
        }
        this.palletsLeft = this.getPallets(this.palletRight);
        this.palletsRight = this.getPallets(this.palletLeft);
        await Helper.timeout(20);
        const palletTop = document.getElementById("right-pallet");
        this.dividerRight = this.getDivider(this.palletRight, palletTop);
      },
      deep: true
    }
  },
  methods: {
    async open(selected) {
      this.palletsCopy = this.copyPallets();
      for (const pallet of selected) {
        if (pallet.truck_id != null) {
          alert(this.$t("product_swapper.choose_free_pallets"));
          this.$emit("unselect");
          this.dialog = false;
          return;
        }
      }
      if (selected.length == 2) {
        const leftIndex = this.palletsCopy
          .map(e => {
            return e.id;
          })
          .indexOf(selected[0].id);
        const rightIndex = this.palletsCopy
          .map(e => {
            return e.id;
          })
          .indexOf(selected[1].id);
        this.palletLeft = this.palletsCopy[leftIndex];
        this.palletRight = this.palletsCopy[rightIndex];
      } else {
        for (const pallet of this.palletsCopy) {
          if (pallet.truck_id == null) {
            if (this.palletLeft == null) {
              this.palletLeft = pallet;
              continue;
            }
            if (this.palletLeft != null && this.palletRight == null) {
              this.palletRight = pallet;
              break;
            }
          }
        }
      }
      this.palletsLeft = this.getPallets(this.palletRight);
      this.palletsRight = this.getPallets(this.palletLeft);
      this.$emit("unselect");
      this.dialog = true;
    },
    copyPallets() {
      const pallets = [];
      this.pallets.forEach(pallet => {
        pallets.push(new Pallet(pallet));
      });
      return pallets;
    },
    getDivider(pallet, palletTop) {
      const minimumDivider = !palletTop
        ? 6
        : pallet.width / (palletTop.offsetHeight - 200);
      const screenWidth = !palletTop ? 600 : pallet.offsetWidth - 200;
      const divider = pallet.length / screenWidth;
      if (minimumDivider >= divider) {
        return 6;
      }
      return minimumDivider;
    },

    /**
     * selects all pallets except matching and not allowed to edit
     * @param {Pallet} pallet - oposing side pallet
     */
    getPallets(pallet) {
      const pallets = [];
      const palletRightId = pallet != null ? pallet.id : null;
      this.palletsCopy.forEach((pallet, i) => {
        if (
          pallet.id != palletRightId &&
          pallet.truck_id == null &&
          pallet.status < 2
        ) {
          const palletNumber = !pallet.number
            ? `${this.$t("pallets_list.pallet")} ${i + 1}`
            : "";
          pallet.text = palletNumber + pallet.toString();
          pallet.value = pallet.id;
          pallets.push(pallet);
        }
      });
      return pallets;
    },

    selectProduct(direction) {
      const selectId = direction == "from" ? "select-from" : "select-to";
      const select = document.getElementById(selectId);
      const selectedProducts = [];
      for (let i = 0; i < select.length; i++) {
        if (select[i].selected) {
          const product = new Product(JSON.parse(select[i].value));
          selectedProducts.push(product);
        }
      }
      //gets all selected products and saves
      if (direction == "from") {
        this.loadingProducts = selectedProducts;
      } else {
        this.unloadingProducts = selectedProducts;
      }
    },

    loadProduct(product) {
      //selects only this products and moves it
      this.loadingProducts = [product];
      this.moveProducts();
    },

    unloadProduct(product) {
      //selects only this product and moves it
      this.unloadingProducts = [product];
      this.moveProducts();
    },

    moveProducts() {
      const palletFrom =
        this.loadingProducts.length > 0 ? this.palletLeft : this.palletRight;
      const palletTo =
        this.loadingProducts.length > 0 ? this.palletRight : this.palletLeft;
      const movingProducts =
        this.loadingProducts.length > 0
          ? this.loadingProducts
          : this.unloadingProducts;
      //remove selected products from old pallet
      movingProducts.forEach(product => {
        const removeIndex = palletFrom.products
          .map(e => {
            return e.id;
          })
          .indexOf(product.id);
        if (removeIndex != -1) {
          palletFrom.products.splice(removeIndex, 1);
        }
      });

      //put products in the new pallet
      movingProducts.forEach(product => {
        const minDimensions = palletTo.minDimensions();
        product["pallet_id"] = palletTo.id;
        product["x"] = palletTo.spacing_ends;
        product["y"] = minDimensions.width + palletTo.spacing_between;
        product["z"] = 0;
        palletTo.products.push(product);
      });
      //recalculate to correct place by moving
      palletFrom.moveOld();
      palletTo.moveOld();
      //TODO figure out why two times needed
      palletFrom.moveOld();
      palletTo.moveOld();
      //update view
      this.$refs.palletTopLeft.initialize();
      this.$refs.palletTopRight.initialize();
      //products are moved, so we don't need to hold them anymore
      this.loadingProducts = [];
      this.unloadingProducts = [];
    },

    async confirm() {
      const products = [
        ...this.palletLeft.products,
        ...this.palletRight.products
      ];
      const updatingPallets = [this.palletLeft, this.palletRight];
      const tempPallet = updatingPallets.find(e => {
        return e.temporary === true;
      });
      if (tempPallet) {
        const createdPallet = await Pallet.createPallet({
          length: tempPallet.length,
          width: tempPallet.width,
          height: tempPallet.height,
          pallet_height: tempPallet.pallet_height,
          spacing_sides: tempPallet.spacing_sides,
          spacing_ends: tempPallet.spacing_ends,
          spacing_between: tempPallet.spacing_between,
          max_weight: tempPallet.max_weight,
          max_height: tempPallet.max_height
        });
        products.forEach(product => {
          if (product.pallet_id == tempPallet.id) {
            product.pallet_id = createdPallet.id;
          }
        });
        this.$emit("removeTemporary");
      }
      this.$store.commit('setLoading', true);
      await Product.save(products);
      if (this.palletLeft.products.length == 0) {
        this.palletLeft.remove();
      }
      if (this.palletRight.products.length == 0) {
        this.palletRight.remove();
      }
      this.$store.commit('setLoading', false);
      this.$emit("updated");
      this.dialog = false;
    },

    loadSelectedProduct(/*product*/) {
      // this.$emit("productSelected", product);
    },

    hideProduct() {
      this.$emit("hideProduct");
    }
  },
  components: {
    PalletTop
  }
};
</script>

<style scoped>
.swapper {
  position: relative;
  width: 100%;
  min-height: 800px;
}
.dialog-buttons {
  position: absolute;
  height: 50px;
  width: 100%;
  bottom: 20px;
}
.confirm-button {
  position: absolute;
  left: 10px;
}
.cancel-buttom {
  position: absolute;
  right: 50px;
}
.pallets-view {
  position: relative;
  width: 100%;
  height: 300px;
}
.left-pallet {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
}
.right-pallet {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
}
.pallet-product-selector {
  position: relative;
  top: 20px;
  width: 100%;
  height: 100px;
}
.pallet-from {
  position: absolute;
  top: 0;
  left: 0;
  width: 400px;
  height: 100%;
}
.pallet-to {
  position: absolute;
  top: 0;
  right: 0;
  width: 400px;
  height: 100%;
}
.product-selector {
  position: relative;
  width: 100%;
  height: 300px;
}
.products-left {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 400px;
}
.products-right {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 400px;
}
.swapper-buttons {
  position: absolute;
  width: calc(100% - 400px - 400px);
  height: 100%;
  left: 400px;
}
.button {
  background-color: rgb(43, 118, 231);
  border: none;
  color: white;
  width: 200px;
  height: 50px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button:disabled {
  background: rgb(151, 142, 142);
  pointer-events: none;
}

.button-hover {
  background-color: white;
  color: black;
  border: 2px solid rgb(43, 118, 231);
}

.button-hover:hover {
  background-color: rgb(43, 118, 231);
  color: white;
}
.upload-button {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 60px;
  right: 0;
}
.delete-button {
  margin: auto;
  position: absolute;
  top: 60px;
  left: 0;
  bottom: 0;
  right: 0;
}
.select {
  width: 100%;
  height: 100%;
}
</style>
